<template>
  <div
    :class="[
      { 'pl-chat-list__message--my': isAuthor && !message.isSystem },
      { 'pl-chat-list__message--someone': !isAuthor && !message.isSystem },
      { 'pl-chat-list__message--system': message.isSystem },
      { 'pl-chat-list__message--selected': isSelected && !message.isSystem },
    ]"
    class="pl-chat-list__message"
  >
    <pl-chat-avatar v-if="!isAuthor && !message.isSystem" :entity="message.user" :entityColor="getColorMessage" />

    <div class="pl-chat-list__message-body ml-3">
      <div v-if="!isAuthor && !message.isSystem" class="pl-chat-list__message-title">
        {{ getAuthorMessageName }}
      </div>
      <div class="pl-chat-list__message-content pr-5" style="color: white">
        <div>
          <div v-if="message.answer && Object.keys(message.answer).length" class="answered-item pl-2">
            <p class="mb-0 font-weight-bold">{{ message.answer.user.name }}</p>
            <p class="mb-0">{{ message.answer.message }}</p>
          </div>

          <div v-if="message.attachments.length">
            <div
              v-for="(attachMessage, index) in message.attachments"
              :key="`message_${message.id}-attachMessage_${index}`"
              class="answered-item pl-2 mb-1"
              @click.stop="
                $emit('newTargetMessage', {
                  messageId: attachMessage.id,
                  refKey: `message_${attachMessage.id}`,
                })
              "
            >
              <p class="mb-0 font-weight-bold">{{ attachMessage.user.name }}</p>
              <file-view
                v-for="(file, index) in attachMessage.files"
                :key="`message_${attachMessage.id}-file_${index}`"
                :file="file"
                @activateGallery="showImages(file)"
              />
              <p class="mb-0" v-html="attachMessage.message" />
            </div>
          </div>

          <p v-for="(line, index) in prepareContent(message.message)" :key="index" v-html="line" class="message-line" />
        </div>

        <div v-if="message.files">
          <file-view
            v-for="(file, index) in sortedMessageFiles"
            :key="`message_${message.id}-file_${index}`"
            :file="file"
            @activateGallery="showImages(file)"
          />
        </div>

        <div v-if="!message.isSystem" class="pl-chat-list__message-buttons">
          <v-icon small color="rgba(255,255,255,0.8)" @click.stop="answerMessage(message)"> question_answer </v-icon>
          <v-icon small color="rgba(255,255,255,0.8)" @click.stop="forwardMessage()"> reply </v-icon>
        </div>
      </div>

      <div class="pl-message-statusbar" v-if="!message.isSystem">
        <div v-if="isAuthor" class="pl-message-statusbar__buttons">
          <v-icon
            small
            class="pl-message-statusbar__button"
            color="rgba(255,255,255,0.8)"
            @click.stop="deleteMessage()"
          >
            clear
          </v-icon>
          <v-icon
            small
            class="pl-message-statusbar__button"
            color="rgba(255,255,255,0.8)"
            @click.stop="editMessage(message)"
          >
            edit
          </v-icon>
        </div>
        <div class="pl-message-statusbar__status">
          <span v-if="isChanged" class="pl-message-statusbar__title"> Изменено: </span>

          <span v-if="isChanged" class="pl-message-statusbar__time pl-message-statusbar__time--changed">
            {{ formatMessageDateTime(message.updatedAt) }}
          </span>

          <span class="pl-message-statusbar__title"> Создано: </span>

          <span class="pl-message-statusbar__time pl-message-statusbar__time--created">
            {{ formatMessageDateTime(message.createdAt) }}
          </span>
        </div>
      </div>
    </div>

    <v-icon
      v-if="!message.isSystem"
      :class="{ 'ml-3': !isAuthor && !message.isSystem }"
      class="pl-chat-list__select-icon"
      color="rgb(0,174,184)"
    >
      check_circle
    </v-icon>
  </div>
</template>

<script>
import { FileView } from './ui'
import PlChatAvatar from './PlChatAvatar'
import moment from 'moment'

export default {
  name: 'PlChatMessage',
  components: {
    PlChatAvatar,
    FileView,
  },
  props: {
    message: Object,
    userProfile: Object,
    members: Array,
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAuthor() {
      return this.message.userId === this.userProfile.id
    },
    isChanged() {
      return this.message.updatedAt !== this.message.createdAt
    },
    sortedMessageFiles() {
      return [...this.message.files].sort(file => {
        if (file.type === 'image') {
          return -1
        } else {
          return 1
        }
      })
    },
    getColorMessage() {
      return '#0a00b6'
    },
    getAuthorMessageName() {
      let value = ''

      if (this.message.user) {
        value = this.message.user.name
      }

      return value
    },
  },
  methods: {
    showImages(targetFile) {
      const images = this.message.files.filter(item => item.type === 'image' && item.id !== targetFile.id)

      this.$store.commit('setImagesGallery', [targetFile, ...images])
    },
    answerMessage(message) {
      this.$store.commit('setActiveAnswerItem', message)
    },
    forwardMessage() {
      if (this.$store.getters['selectedMessages'].some(item => item.id === this.message.id)) {
        return
      }

      this.$store.commit('addMessageToSelected', this.message)
      this.$emit('forwardEventByMessage')
    },
    deleteMessage() {
      this.$store.dispatch('deleteMessage', this.message)
    },
    editMessage(message) {
      this.$store.commit('setEditMessage', message)

      if (message.attachments.length) {
        this.$store.commit('setActiveAnswerItem', message.attachments[0])
      }
    },
    formatMessageDateTime(dataTime) {
      if (moment().format('YYYY-MM-DD') === this.$formatDate(dataTime, 'YYYY-MM-DD')) {
        return moment(dataTime).format('HH:mm')
      }
      return this.$formatDate(dataTime, 'DD.MM.YYYY HH:mm')
    },
    prepareContent(text) {
      return text.split('\n')
    },
  },
}
</script>

<style lang="scss">
.application .pl-chat-list {
  &__message-content {
    a {
      color: white;

      &:hover {
        text-decoration: underline;
      }
    }
    p {
      margin-bottom: 0.5rem;
    }
  }
}
</style>

<style scoped lang="scss">
.pl-chat-list {
  &__message {
    max-width: 80%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: flex-end;

    &:hover .pl-chat-list__select-icon {
      opacity: 0.4;
    }

    &.pl-chat-list__message--selected {
      .pl-chat-list__select-icon {
        opacity: 1;
      }
    }
  }

  &__file-img {
    max-width: 100%;
  }

  &__select-icon {
    opacity: 0;
  }

  &__message-content {
    .answered-item {
      color: rgba(0, 0, 0, 0.5);
      border-left: 2px solid rgba(0, 0, 0, 0.5);
    }

    .message-line {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
    }
  }

  &__message-buttons {
    opacity: 0;
    position: absolute;
    right: 4px;
    top: 8px;
    transition: opacity 0.3s ease-in-out;
  }

  &__message-body {
    position: relative;
    max-width: 100%;
    padding: 0.7rem;

    a {
    }

    &--selected {
      filter: grayscale(1);
    }

    &::before {
      content: '';
      position: absolute;
      width: 1rem;
      height: 1rem;
      bottom: 0;
    }

    &::after {
      content: '';
      position: absolute;
      height: 2rem;
      background-color: white;
      bottom: 0;
    }

    &:hover {
      & .pl-message-statusbar__title {
        max-width: none;
        opacity: 1;
      }

      & .pl-message-statusbar__buttons,
      & .pl-message-statusbar__time--changed,
      & .pl-chat-list__message-buttons {
        opacity: 1;
      }
    }
  }

  &__message-title {
    font-weight: bolder;
    font-size: 0.9rem;
  }

  &__message--someone {
    margin-left: 0;
    margin-right: auto;
    cursor: pointer;

    & .pl-chat-list__message-body {
      padding-right: 45px;
      background-color: rgba(0, 0, 0, 0.4);
      color: rgba(255, 255, 255, 0.8);
      border-radius: 4px 4px 4px 0;

      &::before {
        background-color: rgba(0, 0, 0, 0.4);
        left: -1rem;
      }

      &::after {
        width: 1rem;
        border-radius: 0 50% 50% 0;
        left: -1rem;
      }
    }
  }

  &__message--my {
    margin-left: auto;
    margin-right: 0.5rem;
    justify-content: flex-end;
    cursor: pointer;

    .pl-chat-list__select-icon {
      order: -1;
    }

    & .pl-chat-list__message-body {
      background-color: rgba(0, 174, 184, 0.8);
      color: rgba(255, 255, 255, 0.8);
      border-radius: 4px 4px 0 4px;

      &::before {
        background-color: rgba(0, 174, 184, 0.8);
        right: -1rem;
      }

      &::after {
        width: 1rem;
        border-radius: 50% 0 0 50%;
        right: -1rem;
      }
    }
  }

  &__message--system {
    max-width: 60%;
    margin-left: auto;
    margin-right: auto;

    & .pl-chat-list__message-body {
      background-color: rgba(0, 0, 0, 0.2);
      color: rgba(0, 0, 0, 0.4);
      border-radius: 2rem;
      border: 1px solid rgba(0, 0, 0, 0.2);
      font-size: 0.9rem;
      margin: 0 auto;
      padding: 0.2rem 1.4rem;

      &::before {
        content: none;
      }

      &::after {
        content: none;
      }
    }
  }

  &__message-statusbar {
    display: flex;
    font-size: 0.8rem;
  }

  &__message-create-time {
  }
}

.pl-message-statusbar {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  font-size: 0.8rem;
  margin-top: 0.2rem;

  &__buttons {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    margin-right: 1rem;
  }

  &_button {
    cursor: pointer;
  }

  &__title,
  &__time--changed {
    margin-right: 0.4rem;
    max-width: 0;
    opacity: 0;
    transition: max-width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }

  &__time {
  }
}
</style>
